'use strict';

export class Profiletabs {
    constructor(component_key) {
        this.id = component_key;
        this.data = yalwa.v.components[component_key];
        this.$root = jQuery(`.js-${this.id}`);
    }

    init() {
        if (!this.$root.length) return;
        this.bind_events();
        //Check if imprint
        this.scroll_tabs();
    }
    scroll_tabs() {
        const tab = yalwa.basics.get_get('tab');
        if (tab === 'imprint' || tab === 'ratings') {
            const nav = document.querySelector('.profiletabs__nav');
            nav.scrollLeft = 200;
        }
    }
    bind_events() {
        this.$root.on('click', 'yalwa-link-button', (e) => {
            const tabId = jQuery(e.currentTarget).closest('.profiletabs__tab').data('tab-id');
            console.log(`Tab selected: ${tabId}`);
            // Additional logic for SPA-like transitions can be added here
        });
    }
}

// Auto-init
Object.keys(yalwa.v.components).forEach(key => {
    if (key.startsWith('profiletabs_')) {
        new Profiletabs(key).init();
    }
});